import React from 'react'
import { HeaderEl } from './elements'
import About from './components/about'
import Overview from './components/overview'
import RecordedCourseDashboardStore from '../../../../stores/RecordedCourseDashboardStore'
import RegistrationModal from './components/registration-modal'

const Header = () => {
  const {
    expanded,
    showRegistrationModal,
  } = RecordedCourseDashboardStore.useContainer()

  return (
    <HeaderEl>
      <About />
      {expanded && <Overview />}
      {showRegistrationModal && <RegistrationModal />}
    </HeaderEl>
  )
}

export default Header
